import { render } from "./BusinessMessages.vue?vue&type=template&id=f6a0d9c0&scoped=true"
import script from "./BusinessMessages.vue?vue&type=script&lang=js"
export * from "./BusinessMessages.vue?vue&type=script&lang=js"

import "./BusinessMessages.vue?vue&type=style&index=0&id=f6a0d9c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6a0d9c0"]])

export default __exports__